import { registerPlugin } from '@capacitor/core';
const WebviewPrint = registerPlugin('WebviewPrint', {
    web: () => import('./web').then(m => new m.WebviewPrintWeb()),
});
export * from './definitions';
export { WebviewPrint };
//# sourceMappingURL=index.js.map